import React from 'react';
import { string } from 'prop-types';

import classNames from 'classnames';
import Button, { ButtonText } from '@andes/button';

import IconFilterToolbar from '../../../../../components-v2/icons/sources/toolbar-filter';
import { NAMESPACE } from '../constants';

/**
 * FiltersButton
 *
 * Renders a button that displays filter controls in the map interface.
 * Shows a filter icon alongside the provided label text.
 * When filters are active, displays a count indicator with totalLabel.
 *
 * @param {Object} props - Component props
 * @param {string} props.label - Main text label for the button
 * @param {string} props.totalLabel - Text showing number of active filters (when present)
 * @returns {React.ReactElement} Rendered filter button component
 */

const FiltersButton = ({ label, totalLabel }) => (
  <Button
    hierarchy="transparent"
    className={classNames(`${NAMESPACE}__filters-button`, {
      [`${NAMESPACE}__filters-button--active-filters`]: totalLabel,
    })}
  >
    <IconFilterToolbar className={`${NAMESPACE}__filters-button--icon`} />
    <ButtonText>{label}</ButtonText>
    {totalLabel && (
      <ButtonText>
        <span className={`${NAMESPACE}__filters-button--text-highlight`}>{totalLabel}</span>
      </ButtonText>
    )}
  </Button>
);

FiltersButton.propTypes = {
  label: string.isRequired,
  totalLabel: string.isRequired,
};

export default FiltersButton;
